// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebaseConfig: {
    apiKey: 'AIzaSyCNg1I-IyUyCpPRHK05IYuRC_mNMjl0W6w',
    authDomain: 'ethio-beans-ef79c.firebaseapp.com',
    projectId: 'ethio-beans-ef79c',
    storageBucket: 'ethio-beans-ef79c.appspot.com',
    messagingSenderId: '729770321630',
    appId: '1:729770321630:web:eb6686411f08c4bef2044f',
    measurementId: 'G-0RT0D0LT75'
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
